import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark, faChevronLeft, faLock } from '@fortawesome/free-solid-svg-icons';
import Logo from '../header/images/logo.png';
import './premium.css';

/**
 * variant="default": logo + buton de închidere (pricing, succes).
 * variant="checkout": „Înapoi" la stânga, logo centrat, „Plată securizată" la dreapta,
 * coloană largă — header fără distrageri, ca în referința de checkout.
 */
const PremiumLayout = ({
  title,
  subtitle,
  children,
  variant = 'default',
  backTo = '/premium',
  backLabel = 'Înapoi la ofertă',
}) => {
  const navigate = useNavigate();
  const goHome = () => navigate('/functionalpagelogin');
  const isCheckout = variant === 'checkout';

  return (
    <div className={`pm-page${isCheckout ? ' pm-page--checkout' : ''}`}>
      <header className={`pm-header${isCheckout ? ' pm-header--checkout' : ''}`}>
        {isCheckout ? (
          <>
            <button type="button" className="pm-back" onClick={() => navigate(backTo)}>
              <FontAwesomeIcon icon={faChevronLeft} aria-hidden="true" />
              <span>{backLabel}</span>
            </button>
            <img src={Logo} alt="ContaLearn" className="pm-logo" onClick={goHome} />
            <span className="pm-secure">
              <FontAwesomeIcon icon={faLock} aria-hidden="true" />
              <span className="pm-secure-label">Plată securizată</span>
            </span>
          </>
        ) : (
          <>
            <img src={Logo} alt="ContaLearn" className="pm-logo" onClick={goHome} />
            <button type="button" className="pm-close" aria-label="Închide" onClick={goHome}>
              <FontAwesomeIcon icon={faXmark} />
            </button>
          </>
        )}
      </header>
      <main className={`pm-main${isCheckout ? ' pm-main--wide' : ''}`}>
        {title && <h1 className="pm-title">{title}</h1>}
        {subtitle && <p className="pm-subtitle">{subtitle}</p>}
        {children}
      </main>
    </div>
  );
};

export default PremiumLayout;
